<template>
	<view class="details">
		<view class="details_head">
			<view class="details_head_a">预计消费：</view>
			<view class="details_head_b">¥{{ (info.amount / 100).toFixed(2) }}</view>
			<view class="details_head_c">
				<text>结算车型：{{ info.bikeType }}</text>
				<text>计费时长：{{ info.duration }}分钟</text>
			</view>
		</view>
		<view class="details_list">
			<view class="details_list_item" v-for="(item, index) in info.memberRidesResponseList" :key="index">
				<view class="details_list_item_a">
					<text>{{ item.bikeType }}</text>
					<text>编号：{{ item.bikeCode }}</text>
				</view>
				<view class="details_list_item_b">
					骑行时间：{{ item.rideStartTime }} ~ {{ item.rideEndTime }} | {{ item.rideTime }}分钟
				</view>
				<view class="details_list_item_b">
					计费时长：{{ item.duration }}分钟
				</view>
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				id: '',
				info: {}
			};
		},
		onLoad(option) {
			this.id = option.id
			this.getInfo()
		},
		methods: {
			getInfo() {
				this.$u.api.ridesDetail({ goodsOrderId: this.id })
					.then(res => {
						if (res.code === 200) {
							console.log(res)
							this.info = res.data
						}
					})
			}
		}
	}
</script>

<style>
	page {
		background: #F7F7F7;
	}
</style>
<style lang="scss" scoped>
.details {
	width: 100%;
	.details_head {
		width: 100%;
		height: 216rpx;
		padding: 30rpx;
		box-sizing: border-box;
		background: #01B6AD;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		.details_head_a {
			font-size: 26rpx;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #FFFFFF;
		}
		.details_head_b {
			font-size: 40rpx;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #FFFFFF;
		}
		.details_head_c {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: space-between;
			text {
				font-size: 26rpx;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #FFFFFF;
			}
		}
	}
	.details_list {
		width: 100%;
		padding: 20rpx;
		box-sizing: border-box;
		.details_list_item {
			width: 100%;
			padding: 24rpx 30rpx;
			box-sizing: border-box;
			background: #FFFFFF;
			border-radius: 20rpx;
			margin-bottom: 20rpx;
			&:last-child {
				margin: 0;
			}
			.details_list_item_a {
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: space-between;
				text {
					&:first-child {
						font-size: 32rpx;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #222222;
					}
					&:last-child {
						font-size: 26rpx;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #666666;
					}
				}
			}
			.details_list_item_b {
				width: 100%;
				margin-top: 16rpx;
				font-size: 28rpx;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #666666;
			}
		}
	}
}
</style>
